import axios from 'axios'

// create an axios instance
const storage = localStorage || sessionStorage
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'http://wgame.wish.server.dodjoy.com/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 85000, // request timeout
  headers: {
    'X-Token': storage.getItem('token') || ''
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers['X-Token'] =  storage.getItem('token') || '';
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    const {code, data, msg} = res
    if (code === 20000) {
      return data
    }
    return Promise.reject(res)
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
